import { Component, Input } from '@angular/core';
import { AvmDateAndTimePipe } from 'src/app/core/pipes/avm-date-and-time.pipe';
import { ByPassSecurityPipe } from 'src/app/core/pipes/by-pass-security.pipe ';
import { FolderDocument } from 'src/app/models/server/folder-document';

@Component({
    selector: 'app-sms-viewer',
    imports: [AvmDateAndTimePipe, ByPassSecurityPipe],
    templateUrl: './sms-viewer.component.html',
    styleUrl: './sms-viewer.component.scss'
})
export class SmsViewerComponent {
    /**
     * Valeur indiquant si le fichier selectionné doit être affiché dans la prévisualisation.
     */
    @Input()
    public displayPreview: Boolean = true;

    /**
     * Document E-mail affiché dans le visualisateur.
     */
    @Input()
    public smsDocument: FolderDocument;

    /**
     * Contenu du SMS.
     */
    @Input()
    public content: string = null;

    /**
     * Expression régulière pour retrouver les séparateurs des n° de téléphone.
     */
    public smsNumbersDelimiterRegex = /;/g;
}
